import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './SafestPlatform.css';

const columns = [
  [
    { seed: 'safe1', big: true },
    { seed: 'safe4', big: false },
  ],
  [
    { seed: 'safe2', big: false },
    { seed: 'safe5', big: true },
  ],
  [
    { seed: 'safe3', big: false },
    { seed: 'safe6', big: true },
  ],
];

function SafestPlatform() {
  useStyles(s);

  return (
    <section className={s.safest}>
      <div className={s.inner}>
        <h2 className={s.heading}>The Safest Platform Keep With Us</h2>
        <div className={s.grid}>
          {columns.map((column, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={s.column}>
              {column.map(({ seed, big }) => (
                <div
                  key={seed}
                  className={`${s.cell} ${big ? s.cellBig : s.cellSmall}`}
                >
                  <img
                    src={`https://picsum.photos/seed/${seed}/440/440`}
                    alt="ASAP courier"
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SafestPlatform;
